<template>
    <div class="flex items-center justify-between w-full px-4 py-4 pb-10" data-cy="container_financial_health_quiz_progress">
        <template v-for="(step, index) in steps" :key="step.id">
            <!-- Step Circle -->
            <div class="flex items-center justify-center w-8 h-8 rounded-full overflow-hidden"
                 :class="getStepClass(index)">
                <!-- Checkmark for completed --> 
                <img v-if="getStepState(index) === 'done'" 
                     :src="getStepIconDone(index)" 
                     :alt="step.label"
                     class="w-8 h-8 object-contain" />
                <!-- Icon for active/inactive -->
                <img v-else 
                     :src="getStepIcon(index)" 
                     
                     :alt="step.label"
                     class="w-8 h-8 object-contain" />
            </div>
            
            <!-- Connector Line (not after last step) -->
            <div v-if="index < steps.length - 1" 
                 class="flex-1 h-0.5"
                 :class="getLineClass(index)">
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "QuizProgressBar",
    props: {
        // Current step index (0-based)
        currentStep: {
            type: Number,
            default: 0
        },
        // Current category index (0-based, for determining which step is active)
        currentCategory: {
            type: Number,
            default: 0
        },
        // Is current page a howto page (shows current category as done)
        isHowToPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            steps: [
                { 
                    id: 'spend', 
                    label: 'ใช้จ่าย',
                    iconActive: require('@/assets/icon/healthcheck/step-spend.webp'),
                    iconDone: require('@/assets/icon/healthcheck/step-spend-done.webp'),
                    iconNull: require('@/assets/icon/healthcheck/step-spend.webp')
                },
                { 
                    id: 'save', 
                    label: 'ออม',
                    iconActive: require('@/assets/icon/healthcheck/step-save.webp'),
                    iconDone: require('@/assets/icon/healthcheck/step-save-done.webp'),
                    iconNull: require('@/assets/icon/healthcheck/step-save-null.webp')
                },
                { 
                    id: 'borrow', 
                    label: 'กู้ยืม',
                    iconActive: require('@/assets/icon/healthcheck/step-borrow.webp'),
                    iconDone: require('@/assets/icon/healthcheck/step-borrow-done.webp'),
                    iconNull: require('@/assets/icon/healthcheck/step-borrow-null.webp')
                },
                { 
                    id: 'plan', 
                    label: 'วางแผน',
                    iconActive: require('@/assets/icon/healthcheck/step-plan.webp'),
                    iconDone: require('@/assets/icon/healthcheck/step-plan-done.webp'),
                    iconNull: require('@/assets/icon/healthcheck/step-plan-null.webp')
                }
            ]
        };
    },
    methods: {
        getStepState(index) {
            // If on howto page, current category is also done
            if (index < this.currentCategory || (index === this.currentCategory && this.isHowToPage)) {
                return 'done';
            } else if (index === this.currentCategory) {
                return 'active';
            }
            return 'inactive';
        },
        getStepClass(index) {
            const state = this.getStepState(index);
            if (state === 'done') {
                return '';
            } else if (state === 'active') {
                return 'bg-white';
            }
            return 'bg-white';
        },
        getStepIconDone(index) { 
            const step = this.steps[index]; 
            return step.iconDone; 
        },
        getStepIcon(index) {
            const state = this.getStepState(index);
            const step = this.steps[index];
            if (state === 'done') {
                return step.iconDone;
            } else if (state === 'active') {
                return step.iconActive;
            }
            return step.iconNull;
        },
        getLineClass(index) {
            // If on howto page, line after current category is also blue
            if (index < this.currentCategory || (index === this.currentCategory && this.isHowToPage)) {
                return 'bg-a-blue-0064ff';
            }
            return 'bg-a-gray-d9d9d9';
        }
    }
};
</script>
